export default {"src":"/_next/static/media/mx-sol-icon3.57e832cc.svg","height":34,"width":34};